export const transformStatusResponse = ({
  currentTimeUtcMillis,
  onCallUntilUtcMillis,
  onCallUntilOffsetMillis,
  isCurrentOnCall,
  isParticipantOfAnyRotation,
  nextOnCallEndUtcMillis,
  nextOnCallEndOffsetMillis,
  nextOnCallStartUtcMillis,
  nextOnCallStartOffsetMillis
}) => {
  return {
    currentDate: currentTimeUtcMillis,
    currentShiftEnd: onCallUntilUtcMillis,
    currentShiftEndOffset: onCallUntilOffsetMillis,
    isOnCall: isCurrentOnCall,
    isParticipantOfAnyRotation: isParticipantOfAnyRotation,
    nextEndDate: nextOnCallEndUtcMillis,
    nextEndOffset: nextOnCallEndOffsetMillis,
    nextStartDate: nextOnCallStartUtcMillis,
    nextStartOffset: nextOnCallStartOffsetMillis
  };
};